import * as React from 'react';
import { GroupServiceGetResponse, RateReliefCalculatorServiceResponse } from '../../services/api';
import { format } from 'date-fns';
import { asPercentageValue, capitalizeFirstLetter } from '../../utils/parse';
import { InputSwitch, InputSwitchChangeEvent } from 'primereact/inputswitch';
import { isReliefAvailableForGroup } from '../../utils/groupList';
import RoleGuard from '../auth/RoleGuard';
import { UserRole } from '../../store/auth';
import { Dialog } from 'primereact/dialog';
import ModalButtons from '../ui/modals/ModalButtons';

export default function GroupOverview({ group, rates, onReliefStatusChange, isLoading }: { group: GroupServiceGetResponse, rates: RateReliefCalculatorServiceResponse, onReliefStatusChange: (v: boolean) => Promise<void>, isLoading: boolean } ) {
  const [isRREnabled, setIsRREnabled] = React.useState<boolean>(isReliefAvailableForGroup(group));
  const [showRRToggleConfirmModal, setShowRRToggleConfirmModal] = React.useState<boolean>(false);

  function handleToggleChange(_e: InputSwitchChangeEvent) {
    setShowRRToggleConfirmModal(true);
  }

  function hideConfirmModal() {
    setShowRRToggleConfirmModal(false);
    setIsRREnabled(isReliefAvailableForGroup(group));
  }

  async function submitRRToggleConfirmation() {
    await onReliefStatusChange(!isRREnabled);
    setIsRREnabled(!isRREnabled);
    setShowRRToggleConfirmModal(false);
  }

  return (
    <>
      <div className="[ grid grid-cols-[auto_1fr] gap-4 mt-4 pt-2 ]">
        <RoleGuard role={UserRole.ACTUARY}>
          <div>Turn {isRREnabled ? 'off' : 'on'} relief options</div>
          <div className="text-right">
            <InputSwitch disabled={!!isLoading} checked={isRREnabled} onChange={handleToggleChange} />
          </div>

          <hr className="col-span-2" />
        </RoleGuard>

        <div>Options eligible:</div>
        <div className="text-right">{capitalizeFirstLetter(rates.optionsEligible!)}</div>
        <hr className="col-span-2" />
        
        {group.policyDetailModel?.reissueDate && (
          <>
            <div>Reissue date:</div>
            <div className="text-right">{format(group.policyDetailModel?.reissueDate, 'MMMM yy')}</div>
            <hr className="col-span-2" />
          </>
        )}

        <div>State:</div>
        <div className="text-right">{group.policyDetailModel?.state_JanReissue}</div>

        <hr className="col-span-2" />

        <div>Group size:</div>
        <div className="text-right">{group.policyDetailModel?.employeeMedCountTOT}</div>

        <hr className="col-span-2" />

        <div>Filter:</div>
        <div className="text-right">{group.policyDetailModel?.riskFilter}</div>

        <hr className="col-span-2" />

        <div>Pure UW:</div>
        <div className="text-right">{asPercentageValue((group.policyDetailModel?.pureUWLoad || 0) * 100)}</div>
      </div>

      {showRRToggleConfirmModal && (
        <Dialog
          header={`Turn relief options ${!isRREnabled ? 'on' : 'off'}?`}
          onHide={hideConfirmModal}
          visible
          draggable={false}
          footer={
            <ModalButtons
              isFormValid={true}
              isLoading={isLoading}
              onCancel={hideConfirmModal}
              onSave={submitRRToggleConfirmation}
              saveLabel={!isRREnabled ? 'yes, enable options' : 'yes, turn off'}
              submitButtonSeverity={!isRREnabled ? undefined : 'danger'}
            />
          }
        >
          This will {!isRREnabled ? 'enable' : 'disable'} rate relief options for the <strong>{group.policyDetailModel?.groupName}</strong> group.
        </Dialog>
      )}

    </>
  );
}